// extracted by mini-css-extract-plugin
module.exports = {"bold":"Edit_bold__1cDeM"};